import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getRoles } from '../../../../services/userRights';
import InformationModal from '../../../../modals/infoModal.jsx';
import { isUndefined } from 'util';
import './costCalcTab.css';

export default class CostCalcTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0
        };

		this.infoModal = null;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
		parcel.carrierCostRequests = [];
        return parcel;
    }

    reloadReferences() {
        return this.handleRequestsChange(this.props.parcel.carrierCostRequests);
    }

	convertToResultEntry(entry) {		
		return {			
			carrierId: entry.carrierId,
			urgencyId: entry.urgencyId,
			cost: entry.cost,
			carrierServiceCode: entry.carrierServiceCode,
			minDeliveryTime: entry.minDeliveryTime,
			maxDeliveryTime: entry.maxDeliveryTime,
			deliveryTimeComment: entry.deliveryTimeComment,
			status: entry.status,
			statusComment: entry.statusComment,
            isSelected: entry.isSelected
		};
	}

    fillModel(parcel) {
		if (this.props.parcel.carrierCostRequests) {
			parcel.carrierCostRequests = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => this.convertToResultEntry(entry));
			parcel.isUrgencyRequest = this.props.parcel.isUrgencyRequest
		}
        return parcel;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors) && errors.selection;
    }

	compareRequestResults(r1, r2) {
		var r1Cost = r1.cost ? numeral(r1.cost).value() : null;
		var r1Error = r1.status === 'Error';

		var r2Cost = r2.cost ? numeral(r2.cost).value() : null;
		var r2Error = r2.status === 'Error';

		if (r1Error && !r2Error) {
			return 1;
		} else if (!r1Error && r2Error) {
			return -1;
		} else if (r1Cost !== null && r2Cost !== null) {
			if (r1Cost === r2Cost) {
				return 0;
			} else if (r1Cost < r2Cost) {
				return -1;
			} else {
				return 1;
			}
		} else if (r1Cost === null && r2Cost === null) {
			if (r1.name === r2.name) {
				return 0;
			} else if (r1.name < r2.name) {
				return -1;
			} else {
				return 1;
			}
		} else if (r2Cost === null) {
			return -1;
		} else {
			return 1;
		}
	}

	handleRequestsChange(costRequests) {
		if (costRequests) {
			costRequests.sort(this.compareRequestResults);
		}
        return this.props.onFieldChange([
            {
                name: "carrierCostRequests",
                value: costRequests
            }
        ]);
    }

	clearCarrier() {
		this.props.onFieldChange([
            {
                name: "carrierId",
                value: null
            }
        ]);
		if (this.props.onFieldEdited) {
			this.props.onFieldEdited("carrierId", null);
		}
	}

    validateForm(fieldName) {
		var result = null;

		if (isUndefined(fieldName)) {
			if (!this.props.parcel.carrierCostRequests || this.props.parcel.carrierCostRequests.length === 0) {
				result = result ? result : {};
				result.selection = "Необходимо запросить актуальную стоимость";
			} else {
				var hasSelection = false;
				this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
					if (entry.isSelected) {
						hasSelection = true;
					}
				});
				if (!hasSelection && !this.props.parcel.isUrgencyRequest) {
					result = result ? result : {};
					result.selection = "Необходимо выбрать один из вариантов доставки";
				}
			}
		}

        return result;
    }

    addPending(carrier) {
        let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
            status: 'Sent',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

    addSkipped(carrier) {
        let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
			isDeliveryTimeSpecified: false,
			deliveryTime: '',
			minDeliveryTime: null,
			maxDeliveryTime: null,
            status: 'Skip',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

	saveResults(carrierId, newEntries) {		
        newEntries.forEach((entry, ind, arr) => {
			entry.isDeliveryTimeSpecified = false;
			entry.deliveryTime = entry.maxDeliveryTime;
        });
        let newStateEntries = [];
        let isFirstEntry = true;
		let isUpdated = false;
        this.props.parcel.carrierCostRequests.forEach((oldEntry, ind, arr) => {
            if (oldEntry.carrierId === carrierId) {
                if (isFirstEntry) {
                    newStateEntries = newStateEntries.concat(newEntries);
                    isFirstEntry = false;
					isUpdated = true;
                }
            } else {
                newStateEntries.push(oldEntry);
            }
        });
		if (!isUpdated) {
            newStateEntries = newStateEntries.concat(newEntries);
		}
		this.handleRequestsChange(newStateEntries);
    }

    markAsFailed(entry, errorMessage) {
		var newEntry = null;
		let newEntries = this.props.parcel.carrierCostRequests;
        newEntries.forEach((stateEntry, ind, arr) => {
            if (stateEntry === entry) {
                stateEntry.status = 'Error';
                stateEntry.statusComment = errorMessage;
				newEntry = stateEntry;
            }
        });
		this.handleRequestsChange(newEntries);
    }

    getCostCalcRequest() {
        let parcelData = null;
		if (this.props.isNew) {
			parcelData = this.props.getParcelModel();
		} else {
			parcelData = this.props.parcel;
		}
		console.log(parcelData);
        var costRequest = {
			subCompanyId: parcelData.subCompanyId,
            departureDate: parcelData.departureDate,
            parcelType: parcelData.parcelType,
            volume: parcelData.volume,
			weight: parcelData.weight,
			length: parcelData.length,
			height: parcelData.height,
			width: parcelData.width,
			recipientContactInfo: parcelData.recipientContactInfo,
			senderContactInfo: parcelData.senderContactInfo,
            packagesCount: parcelData.packagesCount,
            shipmentAddressId: parcelData.shipmentAddressId,
            shipmentAddress: parcelData.shipmentAddress,
            deliveryAddressId: parcelData.deliveryAddressId,
            deliveryAddress: parcelData.deliveryAddress,
			isReturnRequested: parcelData.isReturnRequested,
			isSelfDelivery: parcelData.isSelfDelivery,
			departamentWorkingHoursId: parcelData.departamentWorkingHoursId
        };
		if (!this.props.isNew) {
			costRequest.parcelId = this.props.parcel.id;
		}
        return costRequest;
    }

	initNewList() {
		this.clearCarrier();
		if (this.props.isNew) {
			return Promise.resolve();
		} else {
			return apiPost('parcels/cost/' + this.props.parcel.id + '/initNewList')
					.then(response => {
						response.costs.forEach((entry, ind, arr) => {
							this.saveResults(entry.carrierId, [entry]);
						});
					});
		}
	}

    sendRequests() {
        var costRequest = this.getCostCalcRequest();
        this.props.clearErrors();
		this.handleRequestsChange([])
			.then(() => {
				this.initNewList()
					.then(() => {
						apiGet('parcels/cost/carriers')
							.then(response => {

								if (response.entries) {
									response.entries.forEach((entry, ind, arr) => {
										if (entry.hasIntegration) {
											let requestEntry = this.addPending(entry);
											apiPost('parcels/cost/calc/' + entry.id, costRequest)
												.then(response => {
													if (response.isComplete) {
														this.saveResults(entry.id, response.costs);
													}
												})
												.catch(err => {
													let errorMessage = err.messages ? err.messages.request : null;
													this.markAsFailed(requestEntry, errorMessage);
												});
										} else if (this.props.isNew) {
											this.addSkipped(entry);
										}
									});
								}
							});
					});
			});
    }

    updateRequests() {
        this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
            if (entry.status === 'Sent' && entry.requestId) {
                apiPost('parcels/cost/calc/refresh', { requestId: entry.requestId })
                    .then(response => {
                        if (response.isComplete) {
                            this.saveResults(entry.carrierId, response.costs);
                        }
                    })
                    .catch(err => {
						let errorMessage = err.messages ? err.messages.request : null;
                        this.markAsFailed(entry, errorMessage);
                    });
            }
        });
    }

    selectCostEntry(entry) {
		if (this.props.isNew) {
			this.props.clearErrors();
			let newEntries = this.props.parcel.carrierCostRequests;
			newEntries.forEach((stateEntry, ind, arr) => {
				if (stateEntry === entry) {
					stateEntry.isSelected = true;
				}
			});
			let fieldUpdates = [
				{
					name: 'carrierId',
					value: entry.carrierId
				},
				{
					name: 'isDeliveryTimeSpecified',
					value: entry.isDeliveryTimeSpecified
				},
				{
					name: 'deliveryTime',
					value: entry.isDeliveryTimeSpecified ? entry.deliveryTime : ''
				},
				{
					name: "carrierCostRequests",
					value: newEntries
				}
			];
			if (entry.status === 'Skip') {
				fieldUpdates.push({
					name: 'deliveryCost',
					value: ''
				});
			} else {
				fieldUpdates.push({
					name: 'urgencyId',
					value: entry.urgencyId
				});
				fieldUpdates.push({
					name: 'deliveryCost',
					value: entry.cost
				});
			}
			this.props.onFieldChange(fieldUpdates);
		} else {
			let data = {
				parcelId: this.props.parcel.id,
				entryId: entry.id,
				isDeliveryTimeSpecified: entry.isDeliveryTimeSpecified,
				deliveryTime: entry.isDeliveryTimeSpecified ? entry.deliveryTime : ''
			};
			apiPost('parcels/cost/select', data)
				.then(() => this.props.reload());
		}
    }

    renderSelectButton(entry, disabled, hasSelection) {
        if ((entry.status === 'Skip' || entry.status === 'Complete') && !hasSelection) {
            return (
                <button className="btn btn-flat btn-default btn-sm pull-right"
                    onClick={() => this.selectCostEntry(entry)}
                    disabled={disabled}
                >
                    Выбрать
                </button>
            );
        } else {
            return null;
        }
    }

    renderEntryStatus(entryStatus, statusComment) {
        if (entryStatus === 'Sent') {
            return <span className="badge bg-yellow" title={statusComment}>Заявка отправлена</span>;
        } else if (entryStatus === 'Error') {
            return <span className="badge bg-red" title={statusComment}>Ошибка</span>;
        } else if (entryStatus === 'Complete') {
            return <span className="badge bg-green" title={statusComment}>Заявка обработана</span>;
        } else if (entryStatus === 'Skip') {
            return <span className="badge bg-blue" title={statusComment}>Без интеграции</span>;
        } else {
            return null;
        }
    }

	onEntryDeliveryTimeChanged(entry, isRequired, value) {
		let validationError = null;
		if (isRequired) {
			if (!value) {
				validationError = 'Необходимо указать предпочтительную дату и время доставки';
			} else if (moment(value) < moment(this.props.parcel.departureDate)) {
				validationError = 'Дата доставки не может быть раньше даты отгрузки';
			}
		}
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.forEach((stateEntry, ind, arr) => {
			if (stateEntry.carrierId === entry.carrierId && stateEntry.urgencyId === entry.urgencyId) {
				stateEntry.isDeliveryTimeSpecified = isRequired;
				stateEntry.deliveryTime = value;
				stateEntry.deliveryTimeError = validationError;
			}
		});
		this.handleRequestsChange(newEntries);
	}

	renderErrorsList() {
		if (this.props.parcel.carrierCostRequests) {
			let entries = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => {
				
				if(entry.status !== "Error")
					return;

				let rowClass = entry.isSelected ? 'bg-green disabled' : '';

				return (
					<tr className={rowClass}>
						<td>
							{entry.carrierName}
						</td>
						<td>
							{entry.statusComment}
						</td>
					</tr>
				);
			});

			if(entries.length === 0)
				return;

			return  <div className="box-body table-responsive">
						<table className="table table-bordered table-hover static-grid">
							<thead>
								<tr>
									<th>Транспортная компания</th>
									<th>Ошибка</th>
								</tr>
							</thead>
							<tbody>
								{entries}
							</tbody>
						</table>
					</div>
		} else {
			return null;
		}
	}

	urgencyRequest() {
		this.props.isNew ? this.props.onFieldChange([{
				name: "isUrgencyRequest",
				value: true
			}]) : this.props.setNewStatus(201);
	}

    renderEntries(disabled) {
		if (this.props.parcel.carrierCostRequests) {
			var hasSelection = false;

            this.props.parcel.carrierCostRequests.sort(this.compareRequestResults);

			this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
				if (entry.isSelected) {
					hasSelection = true;
				}
			});
			if (this.props.parcel.isUrgencyRequest) hasSelection = true;

			let btn = <tr key={'btn_urgencyRequest'} className={this.props.parcel.isUrgencyRequest ? 'bg-green disabled' : ''}>
				<td>
					<button className="btn btn-flat btn-default btn-sm btn-tool" disabled={hasSelection} onClick={() => this.urgencyRequest()}>
						Срочная доставка спец. курьером
						<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="– если заявка оформлена до 16.00, забор документов в 9.00-10.00 утра следующего дня с доставкой в течение 2-4 часов,
– если заявка оформлена до 10.00 утра возможна доставка день в день с забором документов после 14.00 и доставкой адресату в течение 2-4 часов."
						   data-content="– если заявка оформлена до 16.00, забор документов в 9.00-10.00 утра следующего дня с доставкой в течение 2-4 часов,
– если заявка оформлена до 10.00 утра возможна доставка день в день с забором документов после 14.00 и доставкой адресату в течение 2-4 часов.">
							<span className="glyphicon glyphicon-question-sign control-help-btn text-blue"></span>
						</a>
					</button>
				</td>
				<td/><td/><td/><td/>
			</tr>;
			let entries = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => {
				let key = 'cost-car-' + entry.carrierId + '-urg-' + (entry.urgencyId ? entry.urgencyId : 'none')+'-code-'+(entry.carrierServiceCode ? entry.carrierServiceCode : 'none');
				let hasErrors = entry.deliveryTimeError !== null 
								&& entry.deliveryTimeError !== undefined
								&& entry.deliveryTimeError.length > 0;
				let selectButton = this.renderSelectButton(entry, disabled || hasErrors, hasSelection);
				let entryStatus = this.renderEntryStatus(entry.status, entry.statusComment);
				let entryCost = entry.cost ? numeral(entry.cost).format("0.00") : '';
				let rowClass = entry.isSelected ? 'bg-green disabled' : '';
				return (
					<tr key={key} className={rowClass}>
						<td>
							<span>{entry.carrierName}</span>
							{selectButton}
						</td>
						<td className="text-right">{entryCost}</td>
						<td>{entry.deliveryTimeComment}</td>
						<td>{entry.urgencyName}</td>
						<td>{entryStatus}</td>
					</tr>
				);
			});
			entries = [btn, ...entries];
			return entries;
		} else {
			return null;
		}
    }

    renderErrors() {
		let errors = [];
        if (this.props.errors.selection) {
			errors.push(<p key="err-selection">{this.props.errors.selection}</p>);
        }
		if (this.props.errors.deliveryTime) {
			errors.push(<p key="err-deliveryTime">{this.props.errors.deliveryTime}</p>);
		}

		if (errors.length > 0) {
            return (
                <div className="callout callout-danger">
                    {errors}
                </div>
            );
        } else {
            return null;
        }
    }

    renderRefreshButton(disabled) {
        let hasEntriesToRefresh = false;
		if (this.props.parcel.carrierCostRequests) {
			this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
				if (entry.requestId) {
					hasEntriesToRefresh = true;
				}
			});
		}
        if (hasEntriesToRefresh) {
            return (
                <button className="btn btn-flat btn-default btn-sm btn-tool"
                    onClick={() => this.updateRequests()}
                    disabled={disabled}
                >
                    Обновить
                </button>
            );
        } else {
            return null;
        }
    }

	openHelpDialog() {
		if (this.infoModal) {
			let title = "Инструкция к форме «Расчет стоимости»";
			let message = "1. Нажмите кнопку «Запросить варианты доставки» для поиска вариантов доставки посылки. \n" 
						+ "2. Выберите один из предложенных вариантов, исходя из стоимости и сроков доставки. \n"
						+ "3. Если вам необходимо доставить груз позже указанной даты, поставьте галочку в соответствующей строке столбца «Доставка к другому времени». Внесите дату в поле «Доставка к другому времени» после его активации. \n"
						+ "4. Нажмите кнопку «Выбрать» рядом с названием транспортной компании для подтверждения выбора варианта доставки.";
			this.infoModal.open(title, message);
		}
	}

	renderHelpButton() {
		return (
            <button className="btn btn-flat btn-default btn-sm btn-tool" onClick={() => this.openHelpDialog()}>
                <span className="glyphicon glyphicon-question-sign control-help-btn text-blue"></span>
				Помощь
            </button>
		);
	}

    renderEmptyForm(disabled) {
        return (
			<div>
				{this.renderHelpButton()}
				<div className="cost-calc-button-wrapper">
					<button className="btn btn-flat btn-default cost-calc-button"
						onClick={() => this.sendRequests()}
						disabled={disabled}
					>
						Запросить варианты доставки
					</button>
				</div>
            </div>
        );
    }

	renderNewRequestButton(disabled)
	{
		return (
            <button className="btn btn-flat btn-default btn-sm btn-tool"
                onClick={() => this.sendRequests()}
                disabled={disabled}
            >
                Обновить варианты доставки
            </button>
		);
	}

    renderTableForm(disabled, canEdit) {
        let entries = this.renderEntries(disabled);
        let refreshButton = canEdit ? this.renderRefreshButton(disabled) : null;
		let newRequestButton = canEdit ? this.renderNewRequestButton(disabled) : null;
		let errorList = this.renderErrorsList();
        return (
            <div>
                <div className="box-header no-vert-padding">
					{this.renderHelpButton()}
                    {refreshButton}
                    {newRequestButton}
                </div>

                <div className="box-body table-responsive">
                    <table className="table table-bordered table-hover static-grid">
                        <thead>
                            <tr>
                                <th>Транспортная компания</th>
                                <th>Стоимость</th>
                                <th>Время доставки</th>
                                <th>Срочность</th>
                                <th>Статус запроса</th>
                            </tr>
                        </thead>
                        <tbody>
                            {entries}
                        </tbody>
                    </table>
                </div>

				{errorList}
            </div>
        );
    }

    render() {
		let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isOnlyBeforeSendEditable = this.props.isNew 
									|| this.props.parcel.statusCode === "Created" 
									|| (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isBusy = this.props.isBusy || this.state.busyCount > 0;
        let errors = this.renderErrors();
        let hasEntries = this.props.parcel.carrierCostRequests && this.props.parcel.carrierCostRequests.length > 0;
        let data = null;
        if (hasEntries || !this.props.isNew || !isOnlyBeforeSendEditable) {
            data = this.renderTableForm(isBusy || !isOnlyBeforeSendEditable, isOnlyBeforeSendEditable);
        } else {
            data = this.renderEmptyForm(isBusy);
        }
        return (
            <div>
                {errors}
                {data}

                <InformationModal ref={modal => this.infoModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/costCalcTab.jsx